import Banner from '../components/Banner';
import MyCarousel from '../components/Carousel';
/*import Contenido from '../components/Contenido';*/
import ContenidoPremium from '../components/ContenidoPremium';
import Footer from '../components/Footer';
import RedesSociales from '../components/RedesSociales';
import BeneficiosDiferencias from '../components/BeneficiosDiferencias';



const Home: React.FC = () => {
  return (
    <div>
      <Banner />
      <MyCarousel />
      <ContenidoPremium />
      <BeneficiosDiferencias />
      <RedesSociales />
      <Footer />
    </div>
  );
};

export default Home;
